import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppState } from '@capacitor/app';
import { ModalController } from '@ionic/angular';
import { Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { NgOTPConfig } from 'src/app/models/ngotp.model';
import { confirmEmail, resendOtp } from 'src/app/store/actions/account.actions';
import { setLoadingSpinner } from 'src/app/store/actions/shared.actions';
import { getUserSession } from 'src/app/store/selectors/auth.selectors';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-verification',
  templateUrl: './verification.component.html',
  styleUrls: ['./verification.component.scss'],
})
export class VerificationComponent implements OnInit {

  @Input() username: any;

  ngUnsubscribe = new Subject();

  userSession$: Observable<any>
  userSession = null;

  config : NgOTPConfig = {
    allowNumbersOnly: true,
    length: 6,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: '',
    inputStyles: {
      'width': 'calc(.5vw + 40px)',
      'height': 'calc(.5vw + 40px)',
      'background': 'white',
      'color': 'black',
      'font-weight' : '800'
    }
  };

  
  timerCtr = environment.resendVerification;
  interval;

  form: FormGroup

  otp: any;

  constructor(
    private modalController: ModalController,
    private fb: FormBuilder,
    private store: Store<AppState>
  ) {
    this.userSession$ = this.store.select(getUserSession)
   }

  ngOnInit() {
    this.form = this.fb.group({
      code: ['', [Validators.required, Validators.minLength(6)]],
    });

    this.userSession$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((userSession) => {
      this.userSession = userSession;
      console.log("userSession$", userSession.accessToken);
    })

    this.startTimer();
  }

  dismiss(flag : boolean){
    this.modalController.dismiss({flag : flag});
  }

  verify(){
    const payload = {
      accessToken: this.userSession.accessToken,
      confirmationCode: this.code.value
    }
    this.store.dispatch(setLoadingSpinner({status: true}));
    this.store.dispatch(confirmEmail({data: payload}));
  }

  startTimer() {
    this.timerCtr = environment.resendVerification;
    this.interval = setInterval(() => {
      if (this.timerCtr > 0) {
        this.timerCtr--;
      } else {
        this.stopTimer();
      }
    }, 1000);
  }

  stopTimer() {
    this.timerCtr = 0;
    clearInterval(this.interval);
  }

  onOtpChange(otp) {
    this.otp = otp;
    if (otp.length == 6) {
      this.form.patchValue({ code: this.otp });
    } else {
      this.form.patchValue({ code: '' });
    }
  }

  resend(){
    this.startTimer();

    const payload = {
      accessToken: this.userSession.accessToken
    }

    this.store.dispatch(setLoadingSpinner({status: true}));
    this.store.dispatch(resendOtp({data: payload}));
  }

  get code(){
    return this.form.get('code');
  }

}
